"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCompactPagination = exports.StyledCompactPaginationPageCounter = exports.StyledCompactPaginationSeparator = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const helpers_1 = require("../../helpers");
const StackView_1 = require("../../StackView");
const Text_1 = require("../../Text");
exports.StyledCompactPaginationSeparator = styled_components_1.default.div `
    display: flex;
    width: ${helpers_1.BASE_BORDER_WIDTH};
    height: ${helpers_1.SPACING_L};
    margin-left: ${helpers_1.SPACING_S};
    margin-right: ${helpers_1.SPACING_S};
    background-color: ${({ theme }) => theme.colorBorderGrid};
`;
exports.StyledCompactPaginationPageCounter = (0, styled_components_1.default)(Text_1.Text) `
    display: flex;
    padding: 0 ${helpers_1.SPACING_S};
`;
exports.StyledCompactPagination = (0, styled_components_1.default)(StackView_1.StackView) `
    display: inline-flex;
`;
//# sourceMappingURL=CompactPagination.styles.js.map